import React from 'react'

function CategoriasCount(props) {

  const handleScrool = (_element) => {
    const element = document.getElementById(_element);
    let elementPosition = null;
    if (element) {
      elementPosition = element.getBoundingClientRect().top;
      window.scrollTo({
        top: elementPosition + window.scrollX - 180,
        behavior: 'smooth',
      });
    }
  }

  return (
    <>
      <div style={{}}>
        <div className="container-fluid">
          <div className="card widget_3">
            <ul className="row m-l-5 clearfix list-unstyled m-b-0">
              <li className={props.valores.transferencias > 0 ? "col-lg-2 col-md-6 col-sm-12 waves-effect" : "col-lg-2 col-md-6 col-sm-12 waves-effect bg-light"} style={{ pointerEvents: props.valores.transferencias > 0 ? 'auto' : 'none' }}>
                <div className="body" style={{ paddingLeft: '0px', paddingRight: '0px', cursor: 'pointer' }} onClick={() => handleScrool('table_transferencias')}>
                  <div className="row">
                    <div className="col-9">
                      <h5 className={props.valores.transferencias > 0 ? "m-t-0" : "m-t-0 col-grey"} style={{ fontSize: '15px' }}>TRANSFERÊNCIAS</h5>
                      {/* <small className="text-small"> <span style={{ whiteSpace: 'pre-wrap' }}> </span> </small> */}
                    </div>
                    <div className="col-3 text-right">
                      <h2 className="" style={{ fontSize: '22px' }}>{props.valores.transferencias ? props.valores.transferencias : 0}</h2>
                      <small className="info"></small>
                    </div>
                    <div className="col-12">
                      <div className="progress m-t-20">
                        <div className="progress-bar l-green" role="progressbar" aria-valuenow="12" aria-valuemin="0" aria-valuemax="100" style={{ width: props.valores.transferencias > 0 ? '100%' : '0%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className={props.valores.indices > 0 ? "col-lg-2 col-md-6 col-sm-12 waves-effect" : "col-lg-2 col-md-6 col-sm-12 waves-effect bg-light"} style={{ pointerEvents: props.valores.indices > 0 ? 'auto' : 'none', marginLeft: '' }}>
                <div className="body" style={{ paddingLeft: '10px', paddingRight: '0px', cursor: 'pointer' }} onClick={() => handleScrool('table_indices')}>
                  <div className="row">
                    <div className="col-9">
                      <h5 className={props.valores.indices > 0 ? "m-t-0" : "m-t-0 col-grey"} style={{ fontSize: '15px' }} > ÍNDICES </h5>
                      {/* <small className="text-small"><span style={{ whiteSpace: 'pre-wrap' }}> </span></small> */}
                    </div>
                    <div className="col-3 text-right">
                      <h2 className="" style={{ fontSize: '22px' }}>{props.valores.indices ? props.valores.indices : 0}</h2>
                      <small className="info"></small>
                    </div>
                    <div className="col-12">
                      <div className="progress m-t-20">
                        <div className="progress-bar l-blush" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: props.valores.indices > 0 ? '100%' : '0%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className={props.valores.dadosBasicos > 0 ? "col-lg-3 col-md-6 col-sm-12 waves-effect" : "col-lg-3 col-md-6 col-sm-12 waves-effect bg-light"} style={{ pointerEvents: props.valores.dadosBasicos > 0 ? 'auto' : 'none' }}>
                <div className="body" style={{ paddingLeft: '10px', paddingRight: '0px', cursor: 'pointer' }} onClick={() => handleScrool('table_dados_basicos')}>
                  <div className="row">
                    <div className="col-7">
                      <h5 className={props.valores.dadosBasicos > 0 ? "m-t-0" : "m-t-0 col-grey"} style={{ fontSize: '15px' }}>DADOS BÁSICOS</h5>
                      {/* <small className={props.valores.dadosBasicos > 0 ? "text-small" : "text-small col-grey"}>GERAL</small> */}
                    </div>
                    <div className="col-5 text-right">
                      <h2 className="" style={{ fontSize: '22px' }}>{props.valores.dadosBasicos ? props.valores.dadosBasicos : 0}</h2>
                      <small className="info"></small>
                    </div>
                    <div className="col-12">
                      <div className="progress m-t-20">
                        <div className="progress-bar l-parpl" role="progressbar" aria-valuenow="39" aria-valuemin="0" aria-valuemax="100" style={{ width: props.valores.dadosBasicos > 0 ? '100%' : '0%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              {props.valores.dadosBasicosSaneamento > 0 &&
                <li className={props.valores.dadosBasicosSaneamento > 0 ? "col-lg-2 col-md-6 col-sm-12 waves-effect" : "col-lg-2 col-md-6 col-sm-12 waves-effect bg-light"} style={{ pointerEvents: props.valores.dadosBasicosSaneamento > 0 ? 'auto' : 'none' }}>

                  <div className="body" style={{ paddingLeft: '10px', paddingRight: '0px', cursor: 'pointer' }} onClick={() => handleScrool('table_dados_basicos_saneamento')}>
                    <div className="row">
                      <div className="col-9">
                        <h5 className={props.valores.dadosBasicosSaneamento > 0 ? "m-t-0" : "m-t-0 col-grey"} style={{ fontSize: '15px' }}> SANEAMENTOS </h5>
                        {/* <small className={props.valores.dadosBasicosSaneamento > 0 ? "text-small" : "text-small col-grey"}>SANEAMENTOS</small> */}
                      </div>
                      <div className="col-3 text-right">
                        <h2 className="" style={{ fontSize: '22px' }}>{props.valores.dadosBasicosSaneamento ? props.valores.dadosBasicosSaneamento : 0}</h2>
                        <small className="info"></small>
                      </div>
                      <div className="col-12">
                        <div className="progress m-t-20">
                          <div className="progress-bar l-blue" role="progressbar" aria-valuenow="89" aria-valuemin="0" aria-valuemax="100" style={{ width: props.valores.dadosBasicosSaneamento > 0 ? '100%' : '0%' }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              }
              <li className={props.valores.dadosBasicosConservacao > 0 ? "col-lg-3 col-md-6 col-sm-12 waves-effect" : "col-lg-3 col-md-6 col-sm-12 waves-effect bg-light"} style={{ pointerEvents: props.valores.dadosBasicosConservacao > 0 ? 'auto' : 'none' }}>

                <div className="body" style={{ paddingLeft: '10px', paddingRight: '0px', cursor: 'pointer' }} onClick={() => handleScrool('table_dados_basicos_conservacao')}>
                  <div className="row">
                    <div className="col-9">
                      <h5 className={props.valores.dadosBasicosConservacao > 0 ? "m-t-0" : "m-t-0 col-grey"} style={{ fontSize: '15px' }}>UNIDADES DE CONSERVAÇÃO </h5>
                      {/* <small className={props.valores.dadosBasicosConservacao > 0 ? "text-small" : "text-small col-grey"}>CONSERVAÇÕES</small> */}
                    </div>
                    <div className="col-3 text-right">
                      <h2 className="" style={{ fontSize: '22px', marginRight: '10px' }}>{props.valores.valoresTableConservacoes && props.valores.valoresTableConservacoes['linhas'] ? props.valores.valoresTableConservacoes['linhas'].length : 0}</h2>
                      <small className="info"></small>
                    </div>
                    <div className="col-12">
                      <div className="progress m-t-20">
                        <div className="progress-bar l-khaki" role="progressbar" aria-valuenow="89" aria-valuemin="0" aria-valuemax="100" style={{ width: props.valores.dadosBasicosConservacao > 0 ? '100%' : '0%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              {/* <li className="col-lg-2 col-md-6 col-sm-12">
                                <div className="body" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                                    <div className="row">
                                        <div className="col-12" style={{ marginTop: '15px' }}>
                                            <h4 className="m-t-5 text-center text-white">CATEGORIAS DISPONIBILIZADAS</h4>
                                            <small className="text-small"></small>
                                        </div>
                                        <div className="col-5 text-right">
                                            <h2 className=""></h2>
                                            <small className="info"></small>
                                        </div>
                                        <div className="col-12">
                                            <div className="progress m-t-20">
                                                <div className="progress-bar l-green" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: '20%' }}></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li> */}
            </ul>
          </div>
        </div>
      </div >
    </>
  )
}

export default CategoriasCount